import { Path, withLeaflet } from 'react-leaflet'

import L from 'leaflet'
import proj4 from 'proj4'
import 'proj4leaflet'

import { epsg, proj } from './BNGMap'

class ZoomTo extends Path {
  updateLeafletElement (from, props) {
    if (from.selectedId !== props.selectedId) {
      this.geoJson.setStyle((feature) => {
        if (feature.properties.id === props.selectedId) {
          return {
            color: '#ffff00',
            fillOpacity: 0,
            opacity: 1
          }
        } else {
          return {
            opacity: 0,
            fillOpacity: 0
          }
        }
      })
      let bounds = {}
      if (props.selectedId === 'gb') {
        bounds = this.gbBounds
      } else {
        bounds = props.data.features.find((feature) => {
          return feature.properties.id === props.selectedId
        })
        bounds = props.data.features.find((feature) => {
          return feature.properties.id === props.selectedId
        }).properties.bounds
      }
      props.leaflet.map.fitBounds(bounds)
    }
  }

  createLeafletElement (props) {
    this.gbBounds = props.leaflet.map.getBounds()
    proj4.defs(epsg, proj)
    this.geoJson = L.Proj.geoJson(props.data, {
      onEachFeature: (feature, layer) => {
        feature.properties.bounds = layer.getBounds()
      },
      style: () => {
        return {
          fillColor: '#ff0000',
          color: '#00ff00',
          opacity: 0,
          fillOpacity: 0
        }
      }
    })
    return this.geoJson
  }
}

export default withLeaflet(ZoomTo)
